<template>
  <div class="row">
    <div class="col-8" :id="`chart${id}`" :ref="`chart${id}`" style="width: 100%"></div>
    <div class="col-4">
      <table v-if="dataExploded != null">
        <tr v-for="(value, index) of dataExploded" :key="index">
          <td>{{ index }}:</td>
          <td>{{ value.title }}</td>
        </tr>        
      </table>
    </div>
  </div>
</template>

<script>

import ApexCharts from 'apexcharts'


export default {
  props: ['chartdata'],

  data() {
    return {
      options : {
        chart: {
          height: 400,
          type: 'bar',
          animations: {
              enabled: true,
              easing: 'linear',
              dynamicAnimation: {
                speed: 500
              }
            },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.selectedData = this.chartdata.bookIds[config.dataPointIndex]
            },
          }
        },
        series: [{
          name: 'displayed',
          data: this.chartdata.yaxis
        }],
        xaxis: {
          categories: this.chartdata.xaxis
        },
      },

      id: Math.floor(Math.random(999) * 100) + Math.floor(Math.random(999) * 100),
      chart: null,

      selectedData: null
    }
  },

  computed: {
    dataExploded() {
      let data = JSON.parse(JSON.stringify(this.selectedData))

      if (data != null) {
        for (let x in data) {
          data[x] = {
            id: data[x],
            title: this.books.find(el => el.id == data[x]).title
          }
        }
      }

      return data
    },
  },

  mounted () {
    this.chart = new ApexCharts(document.querySelector(`#chart${this.id}`), this.options);

    this.chart.render();
  },

  watch: {
    chartdata: function (val) {
      this.chart.updateSeries([{
        data: this.chartdata.yaxis
      }])
    }
  }
}
</script>

<style>
</style>
